import { Injectable } from '@angular/core';
import { sustentosModulo } from 'src/app/aplicaciones-modulos/sustentos/diccionarios/sustentosModulo';
import { ClaveValorModel } from '../models/claveValorModel';
import { Observable } from 'rxjs';
import { RetencionModel } from '../models/retencionModel';
import { ResponseRetencionModel } from '../models/responseRetencionModel';
import { SelectedGridRetencionModel } from '../models/selectGridRetencionModel';
import { SustentoDocRetModel } from '../models/sustentoDocRetModel';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class RetencionService {

  urlSustentos: string;
  diccionarioUrl: any;

  constructor(private _commom: CommonService,
    private _util: UtilsService) {
    this.urlSustentos = this._util.getSustentos();
    this.diccionarioUrl = sustentosModulo.url.sustentos;
  }

  getAnios(): Observable<ClaveValorModel[]> {
      return this._commom.peticionGetConHeader(this.urlSustentos + this.diccionarioUrl.anios);
  }

  getRetencion(data: RetencionModel): Observable<ResponseRetencionModel[]> {
      return this._commom.peticionPostConHeader(this.urlSustentos + this.diccionarioUrl.getRetencion, data);
  }

  postRetencion(data: ResponseRetencionModel): Observable<SelectedGridRetencionModel>{
    return this._commom.peticionPostConHeader(this.urlSustentos + this.diccionarioUrl.postRetencion, data);
  }

  updateStatusDoc(data:SustentoDocRetModel, option:string) {
    return this._commom.peticionPutConHeader(this.urlSustentos + this.diccionarioUrl.updateStatusRet + option , data);
  }

  uploadSustento(data:any, option?:boolean) {
    return this._commom.peticionPostConHeader(this.urlSustentos + this.diccionarioUrl.updateRet + option +'&indexSustento=0&cantSustPago=0', data);
  }

}